// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2FgPh","header":"MessagesList_header__1jX1a","chat":"MessagesList_chat__3OXAe"};